import { State } from './types';
import { EnergyProductionInfo } from '@/types/energy-production/EnergyProductionInfo';
import { RawData } from '@/types/energy-production/RawData';

export const state: State = {
    rawData: {} as RawData,
    production: {} as EnergyProductionInfo,
};
